import { Typography, TypographyProps } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { ReactNode } from "react";
import {
  DEFAULT_FONTSIZE,
  // DEFAULT_TEXT_COLOR,
  DEFAULT_TEXT_FONT_WEIGHT,
  // DEFAULT_TEXT_LINE_HEIGHT,
} from "../utils/utils";
import { CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

type TextProps = {
  children: ReactNode;
  w?: string | number;
  c?: string;
  size?: string | number;
  isTabletext?: boolean;
  variant?: Variant | "inherit";
  fontWeight?: TypographyProps["fontWeight"];
  lineHeight?: TypographyProps["lineHeight"];
} & TypographyProps;

const Text = ({
  w,
  c,
  size = DEFAULT_FONTSIZE.fontSize,
  isTabletext,
  variant,
  fontWeight,
  lineHeight,
  children,
  ...others
}: TextProps) => {
  return (
    <Typography
      width={w}
      color={c}
      fontSize={isTabletext ? CHART_TYPOGRAPHY.body5.fontSize : size}
      fontWeight={fontWeight ?? DEFAULT_TEXT_FONT_WEIGHT}
      // lineHeight={lineHeight ?? DEFAULT_TEXT_LINE_HEIGHT}
      variant={variant}
      textTransform={others?.textTransform ?? "none"}
      {...others}
    >
      {children}
    </Typography>
  );
};

export default Text;
